export const pricingTranslate = {
    es : {
        title: "Adquiérela y disfruta los beneficios de ser Viva Fan",
        subtitle: "",
        benefitsTitle: "Viaja cuanto quieras con tu membresía "

    },
    eng : {
        title: "Add Viva Fan and enjoy all the benefits.",
        subtitle: "",
        benefitsTitle: "Travel as much as you want with your membership"
    }
}